export const map = {
    components: {
       
    },
    pages: {
        homepage: {
            index: require('pages/homepage/homepage-index.desktop')
        },
        contact: {
            index: require('pages/contact/contact-index.desktop')
        }
    }
};
